import React from "react";

const Alert = ({ 
  type = "error", 
  message, 
  onClose, 
  className = "",
  showIcon = true 
}) => {
  if (!message) return null;

  const getIcon = () => {
    if (!showIcon) return null;

    switch (type) {
      case "error":
        return (
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        );
      case "success":
        return (
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
        );
      case "warning":
        return (
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        );
      case "info":
        return (
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const getStyles = () => {
    switch (type) {
      case "error":
        return {
          background: "#fff1f2",
          border: "1px solid #fecdd3",
          color: "#e11d48"
        };
      case "success":
        return {
          background: "#f0fdf4",
          border: "1px solid #bbf7d0",
          color: "#16a34a"
        };
      case "warning":
        return {
          background: "#fffbeb",
          border: "1px solid #fed7aa",
          color: "#ea580c"
        };
      case "info":
        return {
          background: "#f0f9ff",
          border: "1px solid #bae6fd",
          color: "#0284c7"
        };
      default:
        return {
          background: "#f8fafc",
          border: "1px solid #e2e8f0",
          color: "#475569"
        };
    }
  };

  const styles = getStyles();

  return (
    <div 
      className={`alert alert-${type} ${className}`}
      style={{
        ...styles,
        fontSize: "13px",
        padding: "10px 14px",
        borderRadius: "8px",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: "9999",
        maxWidth: "400px",
        width: "auto",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
      }}
    >
      {getIcon()}
      <span style={{ flex: 1 }}>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "currentColor",
            cursor: "pointer",
            padding: "0",
            display: "flex",
            alignItems: "center",
            opacity: 0.7
          }}
          onMouseEnter={(e) => e.target.style.opacity = "1"}
          onMouseLeave={(e) => e.target.style.opacity = "0.7"}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default Alert;
